import { Button } from '@luminara/ui-components';
import { HealerBankDetailsPresentation } from '../../../store/selectors/healer-bank-details.selector';
import { InputField } from '../UI/Input/InputField';
import AddressData from './address-data/AddressData';
import BankData from './bank-data/BankData';
import BankDetailsTabs from './bank-details-tabs/BankDetailsTabs';

export const BankDetailsFields = ({
  data,
  email,
  name,
  surname,
  achRoutingNumber,
  accountNumber,
  accountType,
  swiftCode,
  ibanCode,
  country,
  city,
  address,
  postCode,
  accountNumberValidationMessage,
  ibanCodeValidationMessage,
  achRoutingNumberValidationMessage,
  swiftCodeValidationMessage,
  showModify,
  handleInputEmailFn,
  handleTabChangeFn,
  handleNameInputFn,
  handleSurnameInputFn,
  handleAchRoutingNumberFn,
  handleAccountNumberFn,
  handleAccountTypeFn,
  hadnleSwiftCodeFn,
  hadnleIbanCodeFn,
  handleCountryFn,
  handleCityFn,
  handleAddressFn,
  handlePostCodeFn,
  submitBankDetailsFn,
  handleModifyClickFn,
  handleCancelClickFn,
}: {
  data: HealerBankDetailsPresentation;
  email?: string;
  name?: string;
  surname?: string;
  achRoutingNumber?: string;
  accountNumber?: string;
  accountType?: string;
  swiftCode?: string;
  ibanCode?: string;
  country?: string;
  city?: string;
  address?: string;
  postCode?: string;
  accountNumberValidationMessage: string | null;
  ibanCodeValidationMessage: string | null;
  achRoutingNumberValidationMessage: string | null;
  swiftCodeValidationMessage: string | null;
  showModify: boolean;
  handleInputEmailFn: (event: any) => void;
  handleTabChangeFn: (tabValue: string) => void;
  handleNameInputFn: (event: any) => void;
  handleSurnameInputFn: (event: any) => void;
  handleAchRoutingNumberFn: (event: any) => void;
  handleAccountNumberFn: (event: any) => void;
  handleAccountTypeFn: (event: any) => void;
  hadnleSwiftCodeFn: (event: any) => void;
  hadnleIbanCodeFn: (event: any) => void;
  handleCountryFn: (event: any) => void;
  handleCityFn: (event: any) => void;
  handleAddressFn: (event: any) => void;
  handlePostCodeFn: (event: any) => void;
  submitBankDetailsFn: () => void;
  handleModifyClickFn: () => void;
  handleCancelClickFn: () => void;
}) => {
  return (
    <div className="mt-10 ml-10">
      <InputField label="Email" id="email" forId="email" type="text" value={email} className=" mb-3" onChange={handleInputEmailFn} readOnly={!showModify} />
      <BankDetailsTabs activeTab={data.type || 'ACH'} handleTabChangeFn={handleTabChangeFn} />
      <BankData
        activeTab={data.type || 'ACH'}
        name={name}
        handleNameInputFn={handleNameInputFn}
        surname={surname}
        handleSurnameInputFn={handleSurnameInputFn}
        achRoutingNumber={achRoutingNumber}
        handleAchRoutingNumberFn={handleAchRoutingNumberFn}
        accountNumber={accountNumber}
        handleAccountNumberFn={handleAccountNumberFn}
        accountType={accountType}
        handleAccountTypeFn={handleAccountTypeFn}
        swiftCode={swiftCode}
        hadnleSwiftCodeFn={hadnleSwiftCodeFn}
        ibanCode={ibanCode}
        hadnleIbanCodeFn={hadnleIbanCodeFn}
        accountNumberValidationMessage={accountNumberValidationMessage}
        ibanCodeValidationMessage={ibanCodeValidationMessage}
        achRoutingNumberValidationMessage={achRoutingNumberValidationMessage}
        swiftCodeValidationMessage={swiftCodeValidationMessage}
        showModify={showModify}
      />
      <AddressData
        country={country}
        handleCountryFn={handleCountryFn}
        city={city}
        handleCityFn={handleCityFn}
        address={address}
        handleAddressFn={handleAddressFn}
        postCode={postCode}
        handlePostCodeFn={handlePostCodeFn}
        showModify={showModify}
      />
      <div>
        {!data.name && !data.surname ? (
          <Button className="mb-8" onClick={submitBankDetailsFn}>
            Confirm
          </Button>
        ) : (
          !showModify && (
            <Button className="mb-8" onClick={handleModifyClickFn}>
              Modify
            </Button>
          )
        )}
        {showModify && data.name && (
          <div className="pb-8">
            <Button size="md4" variant="outline" onClick={handleCancelClickFn}>
              Cancel
            </Button>
            <Button size="md4" variant="accent" className="ml-4" onClick={submitBankDetailsFn}>
              Confirm
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankDetailsFields;
